"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FOCUSABLE_ELEMENT_SELECTORS = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex], [contenteditable]";
const KEY_CODE_MAP = {
  TAB: 9,
  ESC: 27
};
const TabbingTrapper = _ref => {
  let {
    escCallback = null,
    focusElement = null,
    children
  } = _ref;
  const trapElemRef = (0, _react.useRef)();
  const initializedRef = (0, _react.useRef)(false);
  const initTryCountRef = (0, _react.useRef)(0);
  const getFocusableElements = el => {
    const allElems = el.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
    const tabbableElems = Array.from(allElems).filter(elem => {
      const tabIndex = elem.getAttribute("tabindex");
      return tabIndex === null || tabIndex === undefined || +tabIndex >= 0;
    });
    return tabbableElems;
  };
  const applyTabTrapping = (0, _react.useCallback)(() => {
    const el = trapElemRef.current;
    if (!el) {
      console.warn("Could not initialize focus-trapping - Element Missing");
      return;
    }
    if (!el.firstChild && initTryCountRef.current < 10) {
      // if the 'firstChild' element is not yet available, try again in 200ms.. give it 2 seconds total
      setTimeout(() => applyTabTrapping(), 200);
      initTryCountRef.current++;
      return;
    } else if (initTryCountRef.current >= 10) {
      // if we've tried for 2 seconds and still no firstChild, give up.. don't need trapping that badly!
      return;
    }
    let focusableElements = getFocusableElements(el);
    let keyboardHandler;

    // Only run if hasn't already been initialized AND there are focusable element
    if (!initializedRef.current && focusableElements.length > 0) {
      // go find targeted focus element, if it exists
      const focusElem = focusElement ? el.querySelector(focusElement) : null;
      // set initial focus to the targeted (or first focusable) element, so that the user can tab through the trapped area
      const initialFocusElement = focusElem ? focusElem : focusableElements[0];
      initialFocusElement.focus();
      keyboardHandler = function keyboardHandler(e) {
        if (e.keyCode === KEY_CODE_MAP.TAB) {
          // re-query focusable elements in case of dynamic changes
          focusableElements = getFocusableElements(el);
          const firstFocusableEl = focusableElements[0],
            lastFocusableEl = focusableElements[focusableElements.length - 1];

          //Rotate Focus if at the end or beginning of the focusable elements
          if (e.shiftKey && document.activeElement === firstFocusableEl) {
            e.preventDefault();
            lastFocusableEl.focus();
          } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
          } else if (!document.activeElement) {
            // if no active element, set focus to the initial focus element
            e.preventDefault();
            initialFocusElement.focus();
          } else if (document.activeElement) {
            // if the focused element is not in the list of focusable elements, set focus to the initial focus element
            // this can happen if the user tabs out of an input into suggestions etc.
            const focusedEl = Array.from(focusableElements).find(el => el === document.activeElement);
            if (!focusedEl) {
              e.preventDefault();
              initialFocusElement.focus();
            }
          }
        } else if (e.keyCode === KEY_CODE_MAP.ESC) {
          if (escCallback && escCallback instanceof Function) {
            escCallback();
          }
        }
      };
      el.addEventListener("keydown", keyboardHandler);
      initializedRef.current = true;
    }
  }, [trapElemRef, initializedRef, focusElement, escCallback]);
  (0, _react.useEffect)(() => {
    if (trapElemRef.current) {
      // delay the application of tab trapping to ensure the DOM is ready
      setTimeout(() => applyTabTrapping(), 300);
    }
  }, [trapElemRef, applyTabTrapping]);
  return /*#__PURE__*/_react.default.createElement("span", {
    ref: trapElemRef
  }, children);
};
TabbingTrapper.propTypes = {
  /** Callback Function to call when user hits ESC key. */
  escCallback: _propTypes.default.func,
  /** The element to have initial focus. CSS Selector string.  */
  focusElement: _propTypes.default.string
};
var _default = exports.default = TabbingTrapper;